import gql from "graphql-tag"
import { useMutation } from "react-apollo"

import { ROOT_QUERY, VANITY_URL_ATTRIBUTES_FRAGMENT } from "graphql/queries/user"
import {
  SetCurrentVanityUrlMutation,
  SetCurrentVanityUrlMutationVariables,
  RootQuery,
  RootQueryVariables
} from "typings/types"

const SET_CURRENT_VANITY_URL_MUTATION = gql`
  mutation SetCurrentVanityUrl($id: Int!) {
    vanityUrl: setCurrentVanityUrl(id: $id) {
      id
      ...VanityUrlAttributes
    }
  }
  ${VANITY_URL_ATTRIBUTES_FRAGMENT}
`

export const useSetCurrentVanityUrl = () =>
  useMutation<SetCurrentVanityUrlMutation, SetCurrentVanityUrlMutationVariables>(SET_CURRENT_VANITY_URL_MUTATION, {
    update: (cache, { data }) => {
      const prevData = cache.readQuery<RootQuery, RootQueryVariables>({ query: ROOT_QUERY })
      if (!prevData) {
        throw new Error("Unexpected: root query should have been loaded.")
      }

      if (data) {
        cache.writeQuery({
          query: ROOT_QUERY,
          data: {
            ...prevData,
            currentVanityUrl: {
              __typename: "VanityUrl",
              ...data.vanityUrl
            }
          }
        })
      }
    }
  })
